module.exports = __webpack_public_path__ + "static/media/technology_doping.d15f6cd3.jpg";